var map = {
	"./LV1.png": 37059,
	"./LV2.png": 73349,
	"./LV3.png": 27110,
	"./LV4.png": 17656,
	"./LV5.png": 5458,
	"./LV6.png": 66306,
	"./LV7.png": 5371,
	"./LV8.png": 7325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67613;